import React from "react";
import { useTranslation } from "react-i18next";

const WithCode = () => {
  //usage of useTranslation i18n
  const { t, ready } = useTranslation();

  return ready ? (
    <>
      (<strong className="text-danger">{t("avec indicatif")}</strong>)
    </>
  ) : null;
};

export default WithCode;
